import type { InjectionKey, Ref } from 'vue';

/**
 * VAアプリ用: 音声分析追跡関数の provide/inject キー
 */
export type TTrackVoiceAnalysis = (id: number, calleeDidNumber?: string) => void;

export const TRACK_VOICE_ANALYSIS_KEY: InjectionKey<Ref<TTrackVoiceAnalysis>>
  = Symbol('TRACK_VOICE_ANALYSIS');

/**
 * VAアプリ用: コール一覧リフレッシュ関数の provide/inject キー
 */
export type TRefreshCallList = () => Promise<void>;

export const REFRESH_CALL_LIST_KEY: InjectionKey<Ref<TRefreshCallList>>
  = Symbol('REFRESH_CALL_LIST');
